import { SaleOrderItemInfo } from '@gtpl/shared-models/sale-management';
import { SaleOrderItemsDetails } from 'libs/shared-models/sale-management/src/lib/sale-order/sale-order-items-details';
import { Repository, EntityRepository } from 'typeorm';
import { SaleOrderItems } from '../sale-order-items.entity';
import { SaleOrder } from '../sale-order.entitiy';


@EntityRepository(SaleOrderItems)
export class SoItemRepository extends Repository<SaleOrderItems>{

    /**
     *
     * @param SaleOrderId the po id
     * gives the items data with combination of brand,varient,pack style,grade
     */
    async getSoItemCombData(soId: number): Promise<any> {
        // console.log(soId)
        const soItemEntity =await this.createQueryBuilder("sale_order_items")
            .select('master_brand_id as brandId,varient_id as varientId,min_grade_id as minGrade,max_grade_id as maxGrade,pouches,pouch_weight as pouchWeight,uom_id as uomId,sum(cases*pouches) as pouchQty,sum(cases) as caseQty')
            .where(`sale_order_id= ${soId}`)
            .groupBy('master_brand_id,varient_id,min_grade_id,max_grade_id,pouches,pouch_weight,uom_id')
            .getRawMany();
        // console.log(poEntity)
        return soItemEntity;
    }

    async getSoItemBrandsData(soId: number): Promise<any> {
        // console.log(soId)
        const soItemEntity =await this.createQueryBuilder("sale_order_items")
            .select('master_brand_id as masterBrandId')
            .where(`sale_order_id= ${soId}`)
            .groupBy('master_brand_id')
            .getRawMany();
        // console.log(poEntity)
        return soItemEntity;
    }

    async getSoItemBrandCombData(soId: number,branddepparameters:string): Promise<any> {
        // console.log(soId)
            let depndentParameters
                // const branddepParameters = 'pack_style'
                //need to get packstyle dep parameters from brands master
            depndentParameters = depndentParameters+'pack_style'
            const soItemEntity =await this.createQueryBuilder("sale_order_items")
            .select('sale_order_item_id as saleOrderItemId,master_brand_id as brandId,category,varient_id as varientId,min_grade_id as minGrade,max_grade_id as maxGrade,item_id as productId,food_type_id as foodTypeId,value_addition_one_id as valAddOneId,value_addition_two_id as valAddTwoId,value_addition_three_id as valAddThreeId,value_addition_four_id as valAddFourId,value_addition_five_id as valAddFiveId,pouches,pouch_weight as pouchWeight,skewer_size_item_id as sizeId,uom_id as uomId,(cases*pouches) as pouchQty,(cases) as caseQty,(pouches*cases*inner_bags) as skewerQty,pack_style_id as packStyleId')
            .where(`sale_order_id= ${soId}`)
            // .groupBy(branddepparameters)
            .getRawMany();
            return soItemEntity;
        
        // console.log(poEntity)
    }

    /**
     *
     * @param SaleOrderId the po id
     * gives the items data with combination of item and skewer size
     */
     async getSoItemSkewerCombData(soId: number): Promise<any> {
        // console.log(soId)
        const soItemSkewerData = this.createQueryBuilder("sale_order_items")
            .select('master_brand_id as brandId,varient_id as varientId,min_grade_id as minGrade,max_grade_id as maxGrade,pouches,pouch_weight as pouchWeight,skewer_size_item_id as sizeId,uom_id as uomId,sum(pouches*cases*inner_bags) as skewerQty')
            .where(`sale_order_id= ${soId}`)
            .groupBy('master_brand_id,varient_id,min_grade_id,max_grade_id,pouches,pouch_weight,skewer_size_item_id,uom_id')
            .getRawMany();
        // console.log(poEntity)
        return soItemSkewerData;
    }

    /**
     *
     * @param SaleOrderId the po id
     * gives the total table data for saleorderid
     */
    async getSaleOrderDetails(soId: number): Promise<SaleOrderItems[]> {
        const saleOrderdata = await this.find({ where: {saleOrderId: soId}});
        return saleOrderdata; 
    }

    async getVariantInfoForSoItem(soItemId: number): Promise<SaleOrderItemInfo> {
        const soItemInfo : SaleOrderItemInfo =await this.createQueryBuilder("sale_order_items")
            .select('saleOrderInfo.sale_order_no as saleOrderNo, sale_order_items.varient_id as variantId, SoInvDetailsInfo.eda_date as edaDate, SoInvDetailsInfo.edl_date as edlDate, SoInvDetailsInfo.end_customer_id as endCustomerId, soaking_style as soakingStyle, soaking_time as soakingTime, item_id as productId,SoInvDetailsInfo.po_number as poNumber')
            .leftJoin('sale_order_items.saleOrderInfo','saleOrderInfo')
            .leftJoin('saleOrderInfo.SoInvDetailsInfo','SoInvDetailsInfo')
            .where(`sale_order_item_id= ${soItemId}`)
            .getRawOne();
        return soItemInfo;
    }

    async getSoItemsInfo(brandId:number){
        const SoItemsData  =await this.createQueryBuilder("sale_order_items")
        .select('saleOrderInfo.sale_order_no as saleOrderNo,saleOrderInfo.sale_order_id as saleOrderId, sale_order_items.varient_id as variantId,sale_order_items.min_grade_id as minGrade,sale_order_items.max_grade_id as maxGrade,sale_order_items.pouches as pouches,sale_order_items.pouch_weight as pouchWeight, sale_order_items.brand_id as brandId, item_id as productId,SoInvDetailsInfo.po_number as poNumber')
        .leftJoin('sale_order_items.saleOrderInfo','saleOrderInfo')
        .leftJoin('saleOrderInfo.SoInvDetailsInfo','SoInvDetailsInfo')
        if(brandId > 0){
            SoItemsData.andWhere(`brand_id = '${brandId}'`)
        }
        const soItemEntity = await SoItemsData.getRawMany();
        return soItemEntity;
    }



}
